import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const company = apiUrl + "/company";
const routes = {
  label: "Company",
  root: company,
  get_all: company + "/get_all",
  get_mine: company + "/get_mine",
  update: company + "/update",
  update_mine: company + "/update_mine",
  update_mine_usage_warning: company + "/update_mine_usage_warning",
  delete: company + "/delete",
  new: company + "/new",
  get_public_info: company + "/get_public_info",
  toggle_status: company + "/toggle_status",
};
export const Company = {
  label: routes.label,
  new: () => postWithToken(routes.new),
  get_mine: () => postWithToken(routes.get_mine),
  get_all: () => postWithToken(routes.get_all),
  update: (company) => postWithToken(routes.update, company),
  update_mine: (company) => postWithToken(routes.update_mine, company),
  get_public_info: (company_id) => postWithToken(routes.get_public_info, { company_id }),
  update_mine_usage_warning: (usage_warning) => postWithToken(routes.update_mine_usage_warning, { usage_warning }),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  toggle_status: (data) => postWithToken(routes.toggle_status, data),
};
